import React, { useCallback } from 'react';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { TreeMapState, useCascader, useCascaderItem } from '../../../hooks/cascader';
import { ListItem } from '../../util/ListItem';
export function CascaderItemAll(props) {
  var parentId = props.parentId,
      children = props.children,
      style = props.style;
  var info = useCascaderItem(parentId);
  var cascader = useCascader();
  var treeMapValue = cascader.treeMapValue,
      _cascader$treeMapData = cascader.treeMapData,
      checkedStrategy = _cascader$treeMapData.checkedStrategy,
      multiple = _cascader$treeMapData.multiple;
  var locale = useLocale('select.select-all');
  var isMultipleIndependent = multiple && checkedStrategy === 'independent';
  var childrenArray = (info === null || info === void 0 ? void 0 : info.children) || [];
  var state = treeMapValue.getCheckedState(childrenArray);
  var checked = state === TreeMapState.SELECTED;
  var indeterminate = state === TreeMapState.PARTIAL;
  var handlerChange = useCallback(function () {
    var id = info.id,
        state = info.state;

    if (state === TreeMapState.SELECTED || state === TreeMapState.PARTIAL) {
      cascader.setItemState(id, TreeMapState.UNSELECTED, function (node) {
        return node.selectable;
      });
      return;
    }

    cascader.setItemState(id, TreeMapState.SELECTED, function (node) {
      return node.selectable;
    });
  }, [info]);
  var multipleIndependentHandlerChange = useCallback(function () {
    var _a;

    var children = info.children;
    var ids = (_a = children === null || children === void 0 ? void 0 : children.filter(function (child) {
      return child.selectable;
    })) === null || _a === void 0 ? void 0 : _a.map(function (_ref) {
      var id = _ref.id;
      return id;
    });

    if (checked || indeterminate) {
      ids === null || ids === void 0 ? void 0 : ids.forEach(function (id) {
        cascader.setItemState(id, TreeMapState.UNSELECTED);
      });
      return;
    }

    ids === null || ids === void 0 ? void 0 : ids.forEach(function (id) {
      cascader.setItemState(id, TreeMapState.SELECTED);
    });
  }, [info, checked, indeterminate]);
  var cls = usePrefixCls('cascader-select-all');
  return React.createElement(ListItem, {
    prefixCls: "cascader-item",
    className: cls,
    checkable: true,
    disabled: info.disabled,
    readonly: info.readonly,
    state: info.state,
    onCheckboxChange: isMultipleIndependent ? multipleIndependentHandlerChange : handlerChange,
    onClick: isMultipleIndependent ? multipleIndependentHandlerChange : handlerChange,
    checked: checked,
    indeterminate: indeterminate,
    style: style
  }, children || locale);
}